/** @type {import('./$types').PageLoad} */
export function load() {
  return {
    allPages: [
      {
        "title": "Austin Classroom Name Picker for Teachers",
        "slug": "austin-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "California Classroom Name Picker for Teachers",
        "slug": "california-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Chicago Classroom Name Picker for Teachers",
        "slug": "chicago-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Dallas Classroom Name Picker for Teachers",
        "slug": "dallas-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Florida Classroom Name Picker for Teachers",
        "slug": "florida-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Georgia Classroom Name Picker for Teachers",
        "slug": "georgia-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Houston Classroom Name Picker for Teachers",
        "slug": "houston-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Los Angeles Classroom Name Picker for Teachers",
        "slug": "los-angeles-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Michigan Classroom Name Picker for Teachers",
        "slug": "michigan-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "New Jersey Classroom Name Picker for Teachers",
        "slug": "new-jersey-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "New York Classroom Name Picker for Teachers",
        "slug": "new-york-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "North Carolina Classroom Name Picker for Teachers",
        "slug": "north-carolina-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Ohio Classroom Name Picker for Teachers",
        "slug": "ohio-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Pennsylvania Classroom Name Picker for Teachers",
        "slug": "pennsylvania-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Philadelphia Classroom Name Picker for Teachers",
        "slug": "philadelphia-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Phoenix Classroom Name Picker for Teachers",
        "slug": "phoenix-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "San Antonio Classroom Name Picker for Teachers",
        "slug": "san-antonio-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "San Diego Classroom Name Picker for Teachers",
        "slug": "san-diego-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Texas Classroom Name Picker for Teachers",
        "slug": "texas-classroom-name-picker",
        "type": "location"
      },
      {
        "title": "Virginia Classroom Name Picker for Teachers",
        "slug": "virginia-classroom-name-picker",
        "type": "location"
      }
    ]
  };
}
